
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/marketplace/templates",
      function () {
        return require("private-next-pages/[locale]/marketplace/templates.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/marketplace/templates"])
      });
    }
  